import React from 'react'
import { TextInputField } from 'view/components/inputs'
import { DataHelper, getEnumValues } from 'model'
import { Locale, Translation } from 'locale'
import { LabelPosition, LabelAlignment } from 'view/styles/constants'

export interface EnumValuesPanelProps<T = any> {
  Enum: T
  enumHelper: DataHelper<any>
  disabled?: boolean
  excludeValues?: T[]
  values: { [index: string]: string }
  onUpdate: (values: { [index: string]: string }) => unknown
}

export const EnumValuesPanel: React.FunctionComponent<EnumValuesPanelProps> = props => {
  const { Enum, enumHelper, excludeValues = [], values, disabled, onUpdate } = props

  const handleUpdateValue = (enumValue: string, mappedValue: string) => onUpdate({ ...values, [enumValue]: mappedValue })

  return (
    <>
      {getEnumValues(Enum)
        .filter(enumValue => !excludeValues.includes(enumValue))
        .map(enumValue => (
          <TextInputField
            key={enumValue}
            label={Locale.translate(Translation.SC_ENUM_VALUE_PREFIX) + enumHelper.getName(enumValue)}
            labelPosition={LabelPosition.Left}
            labelAlignment={LabelAlignment.Right}
            disabled={disabled}
            value={values[enumValue]}
            onUpdate={(value: string) => handleUpdateValue(enumValue, value)}
          />
        ))}
    </>
  )
}
